<template>
  <div class="modal" v-show="isShow">
    <div class="mask" @click="hideModal"></div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      hideModal () {
        this.$emit('hideModal')
      }
    }
  }
</script>

<style scoped lang="less">
  .modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.7);
    }
  }
</style>
